import React from 'react';
import styles from './Analytics.module.css';

interface ProgressBarProps {
  pdzPercent: number;
  freePercent: number;
  showPdz?: boolean;
}

export const ProgressBar = ({
  pdzPercent,
  freePercent,
  showPdz = true,
}: ProgressBarProps) => (
  <div className={styles.progress}>
    <div className={styles.progressBar}>
      <div className={styles.progressFact}>
        {showPdz && (
          <div
            className={styles.progressPdz}
            style={{ width: `${pdzPercent}%` }}
          />
        )}
      </div>
      <div
        className={styles.progressFree}
        style={{ width: `${freePercent}%` }}
      />
    </div>
  </div>
);
